export interface User {
    userid: number;
    username: string;
    country: string;
    password: string;
    birthdate: string;
    loginmethod: string;
    token: string;
    note: string;
    customerid: string;
    username_alias: string;
    current_account: number;
    saving_account: number;
    credit_card: number;
    loan: number;
    build_saving: number;
    flags: string[];
    envs: string[];
}

export type TokenGenerator = (user: User) => Promise<{ accessToken: string }>;
export type GetTokenGeneratorUrl = (user: User) => string;

type TokenUrlHandler = (user: User) => string;

class TokenError extends Error {
    data?: unknown;

    constructor(data?: unknown) {
        super('Authentication failed');

        this.data = data;
    }
}

export function getToken(tokenUrl: string | TokenUrlHandler): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
        });

        const url = typeof tokenUrl === 'string' ? tokenUrl : tokenUrl(user);

        const response = await fetch(`https://dev-proxy-server.kek.g-labs.io/cors-proxy/${url}`, {
            method: 'POST',
            body: JSON.stringify({
                username: user.username,
                platform: 'web',
            }),
            headers,
        });
        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}

export function getHUToken(tokenUrl: string): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
            authorization: `Basic ${btoa('_egit_apigw_ws:12345678')}`,
        });

        const response = await fetch(
            `https://dev-proxy-server.kek.g-labs.io/cors-proxy/${tokenUrl}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    username: user.username,
                    platform: 'web',
                }),
                headers,
            },
        );
        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}

export function getROToken(tokenUrl: string): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
        });

        const response = await fetch(
            `https://dev-proxy-server.kek.g-labs.io/cors-proxy/${tokenUrl}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    username: user.username,
                    platform: 'web',
                }),
                headers,
            },
        );
        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}

export function getSKToken(tokenUrl: string): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
            authorization: `Basic ${btoa('fat-token-consumer:PqfdbC5v4i3X2nvs')}`,
        });

        const response = await fetch(
            `https://dev-proxy-server.kek.g-labs.io/cors-proxy/${tokenUrl}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    username: user.username,
                    password: user.password,
                    platform: 'web',
                }),
                headers,
            },
        );
        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}

export function getCZToken(tokenUrl: string): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
            'web-api-key': 'f2a4ba2c-299a-458b-89d2-b3eed6b10333',
        });

        const response = await fetch(
            `https://dev-proxy-server.kek.g-labs.io/cors-proxy/${tokenUrl}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    username: user.username,
                    platform: 'web',
                }),
                headers,
            },
        );

        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}

export function getHRToken(tokenUrl: string): TokenGenerator {
    return async (user: User): Promise<{ accessToken: string }> => {
        const headers = new Headers({
            'content-type': 'application/json',
        });

        const response = await fetch(
            `https://dev-proxy-server.kek.g-labs.io/cors-proxy/${tokenUrl}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    username: user.username,
                    platform: 'web',
                    withoutSigning: false,
                    requestorId: '31524647100b922c4b7b656c459830bc1da5b163045d6653a52edd23403c8254',
                }),
                headers,
            },
        );

        const data = await response.json();

        if (!response.ok) {
            throw new TokenError(data);
        }

        return { accessToken: data.accessToken };
    };
}
